import {Pipe, PipeTransform} from "@angular/core";
import {Temporal} from "temporal-polyfill";
import {GjeldendeTidssone, Tidssoneinformasjon} from "../tjenester/i18n/GjeldendeTidssone";
import {fraMillisSidenEpostTilZoneDateTime} from "../støttefunksjoner/temporal";
import ZonedDateTime = Temporal.ZonedDateTime;

/**
 * Leser angitt verdi (millis fra epoch) og konverterer så denne til ZonedDateTime i brukers tidssone.
 * Angitt tall er av typen number og er millis siden epoch i UTC
 */
@Pipe({name: 'millissidenepochSomZonedDateTime', pure: true, standalone: true})
export class MillisSidenEpochSomZonedDateTime implements PipeTransform {
    constructor(private gjeldendeTidssone: GjeldendeTidssone) {
    }

    transform(millisSindenEpoch: number | null, tidssone: Tidssoneinformasjon = this.gjeldendeTidssone.brukersTidssone()): ZonedDateTime | null {
        if (millisSindenEpoch === null) return null;
        return fraMillisSidenEpostTilZoneDateTime(millisSindenEpoch, tidssone)
    }
}
